import React from "react";
// React Table
import { Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaVinculacion = ({ datosVinculacion }) => {
  return (
    <Table bordered responsive>
      <tbody>
        <tr>
          <CustomTd className={"w-50"}>
            <span>Descripción de la Vinculación</span>
          </CustomTd>
          <td>{datosVinculacion?.description || <small>No especificado</small>}</td>
        </tr>
        <tr>
          <CustomTd>
            <span>Vinculación Con</span>
          </CustomTd>
          <td>{datosVinculacion?.type || <small>No especificado</small>}</td>
        </tr>
      </tbody>
    </Table>
  );
};

export default VistaVinculacion;
